import React from 'react'
import { Box } from '@mui/material'
import { Brand, Position, State } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { calculatorOfBaseCost, calculatorOfEmbroideryCost, calculatorOfOptionCost } from 'src/logic/calculateCost/glove'
import { PriceDisplay } from 'src/Components/Domain/PriceDisplay'
import { getPriceUnit } from 'src/util'

type Props = {
  state: State
  brand: Brand
  position: Position
}
export const PriceArea: React.FC<Props> = ({ state, brand, position }) => {
  const { t, locale, language } = useLocale()

  // gorillaは seriesが変わる
  const seriesOrKindsValue = ['atoms'].includes(state.baseModel?.brand) ? state.kinds?.value : state.series?.value
  const basePrice = calculatorOfBaseCost(state.baseModel, seriesOrKindsValue, language)
  const embroideryPrice = calculatorOfEmbroideryCost(brand, t, state, language)
  const optionPrice = calculatorOfOptionCost(brand, position, state, language)
  const totalPrice = basePrice + embroideryPrice + (optionPrice || 0)
  const unit = getPriceUnit(locale)

  return (
    <Box border={'solid 1px #eee'} p={1} my={1}>
      <PriceDisplay priceLabel={t.BASE_PRICE} priceValue={basePrice} unit={unit} />
      <PriceDisplay priceLabel={t.EMBROIDERY_PRICE} priceValue={embroideryPrice} unit={unit} />
      <PriceDisplay priceLabel={t.OPTION_PRICE} priceValue={optionPrice} unit={unit} />
      <PriceDisplay priceLabel={t.TOTAL_PRICE} priceValue={totalPrice} unit={unit} />
      <Box fontSize={'small'} mt={1}>
        ※{t.EXPLANATION_OF_PRICES}
      </Box>
    </Box>
  )
}
